const TwitterHost = 'https://twitter.com/'

const WidgetTypeLibrary = [{
    type: "collection",
    identifier: "/timelines/"
}, {
    type: "tweet",
    // identifier: "/status/"
    identifier: "twitter-tweet"
}, {
    type: "list",
    identifier: "/lists/"
}, {
    type: "profile",
    identifier: "twitter-timeline",
    sharedIdents: [
        "/lists/",
        "/hashtag/"
    ]
}]

/*
    @DEPRECATED by Twitter:
    https://twittercommunity.com/t/replacing-deprecated-timeline-search-widget/103627/13

    {
        type: "hashtag",
        identifier: "twitter-hashtag-button"
    }, {
        type: "search",
        identifier: "data-widget-id=\""
    }
*/

export default {
    detectType: function (value) {
        let foundMatch = false;
        let db = 0;

        for (let i = 0; i < WidgetTypeLibrary.length; i++) {
            db = i
            
            let t = WidgetTypeLibrary[i];
            let r = new RegExp(t.identifier);
            let m = value.search(r);

            if (t.sharedIdents && foundMatch === false) {
                
                let isAlt = false;
                let l = t.sharedIdents.length;

                while (l--) {
                    let ident = t.sharedIdents[l];
                    let searchResult = value.search(new RegExp(ident));
                    if (searchResult !== -1) {
                        m = searchResult;
                        break;
                    }
                }
            }

            if (m !== -1) {
                foundMatch = {
                    type: t.type,
                    matchIndex: m,
                    identifier: t.identifier
                };
            }
        }

        return foundMatch;
    },
    parseValues: function (match, value) {
        let hostMatch = value.search(new RegExp(TwitterHost))

        try {
            // Substring of targeted unique identifier for widget type
            let sub = false;

            switch (match.type) {
                case 'profile':
                case 'collection':
                case 'list':
                case 'hashtag':
                    sub = value.substring(
                        hostMatch + TwitterHost.length,
                        value.length
                    );
                    break;

                case 'tweet':
                    var lastInstance = value.lastIndexOf(TwitterHost);
                    sub = value.substring(
                        lastInstance + TwitterHost.length,
                        value.length
                    );
                    break;

                case 'search':
                    sub = value.substring(
                        match.matchIndex + match.identifier.length,
                        value.length
                    );
                    break;
            }
            
            if (sub) {
                return {
                    value: sub.substring(0, sub.indexOf('"')),
                    widgetType: match.type
                }
            } else {
                throw new Error('No substring found. Could not get Widget Values.');
            }
        } catch (e) {
            console.warn(e);
            return false
        }
    }
}